import {
    InvoiceLineItemColumn,
    InvoiceLineItemView,
} from "@common/types/views/invoiceViews";
import { NamedView, ViewType } from "@common/types/views/views";

export const ACCRUAL_REVIEW_INVOICE_LINE_ITEMS_VIEW_ID = "accrual-review";

export const createAccrualReviewInvoiceLineItemsView = ({
    createdOnFrom,
    createdOnTo,
}: {
    createdOnFrom: string;
    createdOnTo: string;
}): NamedView<InvoiceLineItemView> => ({
    id: ACCRUAL_REVIEW_INVOICE_LINE_ITEMS_VIEW_ID,
    name: "Accrual review",
    type: ViewType.INVOICE_LINE_ITEM,
    options: {
        selection: true,
        bulkActions: true,
    },
    columns: [
        { id: InvoiceLineItemColumn.DATE, options: { pin: "left" } },
        { id: InvoiceLineItemColumn.CUSTOMER },
        { id: InvoiceLineItemColumn.ITEM },
        { id: InvoiceLineItemColumn.DESCRIPTION },
        { id: InvoiceLineItemColumn.AMOUNT },
        { id: InvoiceLineItemColumn.ACCRUAL_ACCOUNT },
        { id: InvoiceLineItemColumn.SCHEDULE },
        { id: InvoiceLineItemColumn.MATCH },
        { id: InvoiceLineItemColumn.DUE_DATE },
        { id: InvoiceLineItemColumn.ACCOUNT },
        { id: InvoiceLineItemColumn.ENTITY, options: { pin: "right" } },
    ],
    filters: {
        createdOnFrom,
        createdOnTo,
    },
});
